(function () {

    'use strict';

    angular.module('iplusjs.fahrzeugsuche', [
        'lodash',
        'iplusjs.config',
        'iplusjs.api.cache',
        'iplusjs.utils.misc'
    ])
    .service('FahrzeugsucheService', FahrzeugsucheService);

    FahrzeugsucheService.$inject = [
        '$log',
        '$http',
        '$q',
        'lodash',
        'AppConfig',
        'ApiCacheService',
        'MiscUtilsService'
    ];
    function FahrzeugsucheService($log, $http, $q, _, AppConfig, ApiCacheService, MiscUtilsService) {
        var that = this,
            komfortsucheProperties = [
                'hersteller',
                'typ',
                'kraftstoff',
                'kategorie',
                'tueren',
                'leistung'
            ],
            detailsucheProperties = [
                'hersteller',
                'modellTyp',
                'leistung',
                'leistungsart',
                'toleranz'
            ];
        that.getModelKomfortsuche = getModelKomfortsuche;
        that.resetModelKomfortsuche = resetModelKomfortsuche;
        that.isErstesMerkmalKomfortsuche = isErstesMerkmalKomfortsuche;
        that.isLetztesMerkmalKomfortsuche = isLetztesMerkmalKomfortsuche;
        that.getCurrentListeUndMerkmalKomfortsuche = getCurrentListeUndMerkmalKomfortsuche;
        that.getNextMerkmalKomfortsuche = getNextMerkmalKomfortsuche;
        that.getPreviousMerkmalKomfortsuche = getPreviousMerkmalKomfortsuche;
        that.komfortsuche = komfortsuche;
        that.detailsuche = detailsuche;
        that.getModelDetailsuche = getModelDetailsuche;
        that.getListenDetailsuche = getListenDetailsuche;

        that.getMerkmalWert = getMerkmalWert;
        function getModelKomfortsuche(model) {
            var newModel = {
                ergebnisListe: []
            };

            komfortsucheProperties.forEach(function (prop) {
                newModel[prop] = {
                    display: null,
                    value: null
                };
            });

            return _.merge(newModel, model);
        }
        function resetModelKomfortsuche(model, resetMerkmal) {
            model = model || {};
            model.ergebnisListe = [];

            _.forEachRight(komfortsucheProperties, function (merkmal) {
                model[merkmal] = {
                    display: null,
                    value: null
                };
                if (_.isArray(model[merkmal + 'Liste'])) {
                    model[merkmal + 'Liste'] = [];
                } else {
                    model[merkmal + 'Liste'] = {
                        alle: [],
                        meistgewaehlte: []
                    };
                }

                if (merkmal === resetMerkmal) {
                    return false;
                }
            });
        }
        function isLetztesMerkmalKomfortsuche(merkmal) {
            return komfortsucheProperties.indexOf(merkmal) === komfortsucheProperties.length - 1;
        }
        function isErstesMerkmalKomfortsuche(merkmal) {
            return komfortsucheProperties.indexOf(merkmal) === 0;
        }
        function isEmptyListeKomfortsuche(liste) {
            return !(
                _.isObject(liste) && ((liste.meistgewaehlte || []).length || (liste.alle || []).length) ||
                _.isArray(liste) && liste.length
            );
        }
        function isEmptyNaechsteListe(merkmal, model) {
            if (isLetztesMerkmalKomfortsuche(merkmal)) {
                return isEmptyListeKomfortsuche(_.get(model, 'ergebnisListe'));
            }
            return isEmptyListeKomfortsuche(_.get(model, getNextMerkmalKomfortsuche(merkmal) + 'Liste'));
        }
        function getPreviousMerkmalKomfortsuche(merkmal) {
            var idx = 0;

            if (isErstesMerkmalKomfortsuche(merkmal)) {
                return merkmal;
            }

            if (merkmal === 'ergebnis') {
                return komfortsucheProperties[komfortsucheProperties.length - 1];
            }

            idx = komfortsucheProperties.indexOf(merkmal);

            return idx !== -1 ? komfortsucheProperties[idx - 1] : null;
        }
        function getNextMerkmalKomfortsuche(merkmal) {
            var idx = 0;

            if (isLetztesMerkmalKomfortsuche(merkmal) || merkmal === 'ergebnis') {
                return merkmal;
            }

            idx = komfortsucheProperties.indexOf(merkmal);

            return idx !== -1 ? komfortsucheProperties[idx + 1] : null;
        }
        function getCurrentListeUndMerkmalKomfortsuche(model) {
            var currentMerkmal = komfortsucheProperties[0],
                currentListe = {
                    meistgewaehlte: [],
                    alle: []
                },
                merkmalListeGefuellt = false;
            if (MiscUtilsService.isEmpty(model) || isEmptyListeKomfortsuche(model[komfortsucheProperties[0] + 'Liste'])) {
                return {
                    merkmal: currentMerkmal
                };
            }
            _.forEachRight(komfortsucheProperties, function (merkmal) {
                var merkmalListe = _.get(model, merkmal + 'Liste', []),
                    merkmalWert = _.get(model, merkmal + '.value');
                if (_.size(model.ergebnisListe)) {
                    currentMerkmal = 'ergebnis';
                    currentListe.alle = model.ergebnisListe;
                    return false;
                } else if (!isEmptyListeKomfortsuche(merkmalListe)) {
                    if (_.isArray(merkmalListe)) {
                        currentListe.meistgewaehlte = [];
                        currentListe.alle = _.slice(merkmalListe);
                        merkmalListeGefuellt = true;
                    } else {
                        currentListe.meistgewaehlte = _.slice(merkmalListe.meistgewaehlte);
                        currentListe.alle = _.slice(merkmalListe.alle);
                        merkmalListeGefuellt = true;
                    }
                }

                currentMerkmal = merkmal;
                if (merkmalWert && merkmalListeGefuellt && isLetztesMerkmalKomfortsuche(merkmal)) {
                    currentListe = {};
                    currentMerkmal = 'ergebnis';
                    return false;
                }
                if (merkmalWert && merkmalListeGefuellt && isEmptyNaechsteListe(merkmal)) {
                    currentListe = {};
                    return false;
                }
                if (!merkmalWert && merkmalListeGefuellt) {
                    return false;
                }
            });

            return {
                liste: currentListe,
                merkmal: currentMerkmal
            };
        }
        function komfortsuche(suche) {
            var result,
                serviceUrl = AppConfig.API.services.fahrzeugsucheKomfort,
                cacheId = getCacheId(serviceUrl, komfortsucheProperties, suche);

            return $q(function (resolve, reject) {
                if (ApiCacheService.isCached(cacheId)) {
                    result = angular.copy(ApiCacheService.get(cacheId)) || {};

                    if (angular.equals(result.suche, suche)) {
                        $log.debug('FahrzeugsucheService.komfortsuche CACHE');
                        return resolve(result);
                    }
                }

                return $http({
                    method: 'POST',
                    url: serviceUrl,
                    data: suche
                }).then(function (response) {
                    $log.debug('FahrzeugsucheService.komfortsuche SUCCESS');

                    result = {
                        suche: suche,
                        suchergebnis: response.data
                    };

                    ApiCacheService.put(cacheId, angular.copy(result));

                    return resolve(result);
                }).catch(function (error) {
                    $log.debug('FahrzeugsucheService.komfortsuche FAILURE');
                    ApiCacheService.remove(cacheId);
                    return reject(error);
                });
            });
        }
        function getModelDetailsuche(model) {
            var newModel = {
                hersteller: null,
                toleranz: {
                    display: '+/- 15',
                    value: 'TOLERANZ15'
                },
                modellTyp: null,
                leistung: null,
                leistungsart: 'kW'
            };

            return _.merge(newModel, model);
        }
        function getListenDetailsuche(ergebnis) {
            ergebnis = ergebnis || {};

            return MiscUtilsService.getValuesAsObject(ergebnis, ['herstellerListe', 'toleranzListe', 'leistungsartListe']);
        }
        function detailsuche(suche) {
            var result,
                serviceUrl = AppConfig.API.services.fahrzeugsucheDetail,
                cacheId = getCacheId(serviceUrl, detailsucheProperties, suche);

            return $q(function (resolve, reject) {
                $log.debug('FahrzeugsucheService.detailsuche suche', suche, cacheId);
                if (ApiCacheService.isCached(cacheId)) {
                    result = angular.copy(ApiCacheService.get(cacheId)) || {};

                    if (angular.equals(result.suche, suche)) {
                        $log.debug('FahrzeugsucheService.detailsuche CACHE', result.suche, suche);
                        return resolve(result);
                    }
                }

                return $http({
                    method: 'POST',
                    url: serviceUrl,
                    data: suche
                }).then(function (response) {
                    $log.debug('FahrzeugsucheService.detailsuche SUCCESS');

                    result = {
                        suche: suche,
                        suchergebnis: response.data
                    };

                    ApiCacheService.put(cacheId, angular.copy(result));

                    return resolve(result);
                }).catch(function (error) {
                    $log.debug('FahrzeugsucheService.detailsuche FAILURE');
                    ApiCacheService.remove(cacheId);
                    return reject(error);
                });
            });
        }
        function getMerkmalWert(merkmal) {
            var value;

            if (_.isObject(merkmal)) {
                value = _.get(merkmal, 'value');
            } else {
                value = merkmal;
            }

            return value;
        }
        function getCacheId(prefix, properties, suche) {
            suche = suche || {};

            var cacheId = [prefix];

            _.forEach(properties, function (prop) {
                var value = getMerkmalWert(suche[prop]);

                if (value) {
                    cacheId.push(prop, value);
                }
            });

            return cacheId.join(':');
        }
    }
})();
